// extracted by mini-css-extract-plugin
export var content = "LeadMagnet-module--content--a19ca";
export var leadMagnet = "LeadMagnet-module--leadMagnet--8a1a1";
export var veilOfDarkness = "LeadMagnet-module--veilOfDarkness--c3fe5";